
























































/* eslint-disable @typescript-eslint/camelcase */
import { Component, Vue } from 'vue-property-decorator';
// import { Route } from 'vue-router';
import hexabaseState from '@/store/hexabase';
// Model
import DataExport from '@/models/dataExportModel';
// Components
import Header from '@/components/common/modules/Header.vue';
import SideMenu from '@/components/common/modules/SideMenu.vue';
import PageInfoBar from '@/components/common/modules/PageInfoBar.vue';
import Dialog from '@/components/common/modules/Dialog.vue';

import MasterSelectControl from '@/components/common/modules/MasterSelectControl.vue';

import {
  DefaultSortRequest,
  DataExportButtons,
  DataReportOutputSelectServiceTypeForm,
  DataReportOutputConditionsForm,
  CatchInputMasterIdList
} from '@/constants/dataexport/dataexport';
import AutoCreateForm from '@/components/form/AutoCreateForm.vue';
import SingleText from '@/components/common/elements/SingleText.vue';
import Button from '@/components/common/elements/Button.vue';

import Encoding from 'encoding-japanese';

@Component({
  components: {
    Header,
    SideMenu,
    PageInfoBar,
    Dialog,
    MasterSelectControl,
    AutoCreateForm,
    SingleText,
    Button
  }
})
export default class DataExportList extends Vue {
  // model
  private dataExport = new DataExport();
  // アプリIDをセット
  private projectId = hexabaseState.applicationId;
  // 画面内ボタン
  private buttons = DataExportButtons;
  // 選択しているデータレポートのid
  private dataReportId = '';
  // マスタデータ関連格納プロパティ
  private masterData: any = {};
  // Payload
  private csvPayload = {
    conditions: [] as Array<{ [key: string]: any }>,
    per_page: 0,
    page: 1,
    use_display_id: true,
    sort_fields: DefaultSortRequest,
    format: 'csv'
  };
  // CSV出力されるファイル名
  private csvFileName = 'download';
  // サービス種別表示パネル
  private dataReportOutputSelectServiceTypeDatas = { cols: {}, datas: {} as { [k: string]: any } };
  // 出力条件表示パネル
  private outputConditionsItems = { cols: {}, datas: {} as { [k: string]: any } };
  // ステータスの選択肢を格納
  private statusOptionList: Array<{ [k: string]: string | number | any }> = [];
  // Dialog
  private apiDialog = false;
  private apiDialogBodyText = '';
  private apiDialogMaxWidth = '800';
  private apiDialogTableColumn: Array<{ [k: string]: string | number }> = [];
  private apiDialogErrData: Array<{ [k: string]: string | any }> = [];

  async created() {
    // 初期表示に必要な情報を取得
    try {
      this.$store.commit('hexabase/setIsLoading', true);

      const [masterData, reporDataSearchConditions] = await Promise.all([
        this.dataExport.getMasterData(),
        this.dataExport.getReportSearchConditions(this.projectId, 'r_csv_output_OA')
      ]);

      this.masterData = masterData;

      this.dataReportOutputSelectServiceTypeDatas = this.getHeaderFields(
        DataReportOutputSelectServiceTypeForm
      );
      const dataReportOutputSelectServiceTypeData = {};
      this.getHeaderData(
        dataReportOutputSelectServiceTypeData,
        this.dataReportOutputSelectServiceTypeDatas
      );
      // 項目；サービス種別カラム、データ設定
      this.dataReportOutputSelectServiceTypeDatas.datas[0].props.columns = this.masterData[
        'm_service_type'
      ]['columns'];
      // サービス種別のマスタ情報に使用するデータレポートがない場合、
      // そのサービス種別はマスタ参照のダイヤログに表示させない
      const filterItem = this.masterData['m_service_type']['body'].filter((item: any) => {
        if (item['data_report_id_for_csv'] !== '' && item['data_report_id_for_csv'] !== undefined) {
          return item;
        }
      });
      this.dataReportOutputSelectServiceTypeDatas.datas[0].props.body = filterItem;
      let serviceTypeFindItem = this.dataFindItem(filterItem, 'service_type', 'OAリース');
      // OAリースが存在しない場合、フィルタリングしたサービス種別の最初の値を表示
      if (serviceTypeFindItem === undefined) {
        serviceTypeFindItem = filterItem[0];
      }
      //参照データレポート(初期値はOAリース)
      this.dataReportId = serviceTypeFindItem.data_report_id_for_csv;
      //項目：サービス種別(初期値はOAリース)
      this.dataReportOutputSelectServiceTypeDatas.datas[0].props.outPutData[0].value =
        serviceTypeFindItem.service_type;
      // 出力条件
      this.outputConditionsItems = this.getHeaderFields(DataReportOutputConditionsForm);
      const dataReportOutputConditionsItemData = {};
      this.getHeaderData(dataReportOutputConditionsItemData, this.outputConditionsItems);

      // ステータス
      const findIndex = this.dataFindIndex(reporDataSearchConditions, 'display_id', 'status');
      this.statusOptionList.push({ text: '全ステータス', value: [] });
      Object.keys(reporDataSearchConditions[findIndex].statuses).forEach(key => {
        reporDataSearchConditions[findIndex].statuses[key].value = [
          reporDataSearchConditions[findIndex].statuses[key].s_id
        ];
        reporDataSearchConditions[findIndex].statuses[key].text =
          reporDataSearchConditions[findIndex].statuses[key].name;
        this.statusOptionList.push(reporDataSearchConditions[findIndex].statuses[key]);
        this.statusOptionList[0].value.push(
          reporDataSearchConditions[findIndex].statuses[key].s_id
        );
      });
      this.outputConditionsItems.datas[1].props.selectData.options = JSON.parse(JSON.stringify(this.statusOptionList));
      this.outputConditionsItems.datas[2].props.columns = this.masterData['m_customer']['columns'];
      this.outputConditionsItems.datas[2].props.body = this.masterData['m_customer']['body'];
      this.outputConditionsItems.datas[3].props.columns = this.masterData['m_company']['columns'];
      this.outputConditionsItems.datas[3].props.body = this.masterData['m_company']['body'];
      const item = JSON.parse(JSON.stringify(this.masterData['m_employee']['columns']));
      // columnに会社名を追加
      item.push({
        'value': 'company_id',
        'text': '会社名',
        'width': '20%'
      });
      this.outputConditionsItems.datas[4].props.columns = item;
      this.outputConditionsItems.datas[4].props.body = this.masterData['m_employee']['body'];
      this.outputConditionsItems.datas[5].props.columns = this.masterData['m_commodity']['columns'];
      this.outputConditionsItems.datas[5].props.body = this.masterData['m_commodity']['body'];
      this.outputConditionsItems.datas[6].props.columns = this.masterData['m_leasing_company'][
        'columns'
      ];
      this.outputConditionsItems.datas[6].props.body = this.masterData['m_leasing_company']['body'];
    } catch (error) {
      this.setError(error);
    } finally {
      this.$store.commit('hexabase/setIsLoading', false);
    }
  }

  async buttonEvent(eventName: string) {
    switch (eventName) {
      case 'clearButton': {
        this.clearButton();
        break;
      }
      case 'SJIS': {
        try {
          // ローディングをセット
          this.$store.commit('hexabase/setIsLoading', true);
          const apiResponseData = await this.dataExport.getReports(
            hexabaseState.applicationId,
            this.dataReportId,
            this.csvPayload
          );
          if (apiResponseData) {
            if (eventName === 'SJIS') {
              // 文字コード変換(UNICODE->SJIS)
              const codeArray = Encoding.stringToCode(apiResponseData.toString());
              const sjisArray = Encoding.convert(codeArray, 'SJIS', 'UNICODE');
              const uInt8List = new Uint8Array(sjisArray);
              // 取得したCSVデータをダウンロード
              this.dataExport.formOutPutDownload(uInt8List, this.csvFileName, 'csv');
            } else {
              // UNICODEのままの場合(BOMなし)
              this.dataExport.formOutPutDownload(apiResponseData, this.csvFileName, 'csv');
            }
          }
        } catch (error) {
          this.setError(error);
        } finally {
          this.$store.commit('hexabase/setIsLoading', false);
        }
        break;
      }
    }
  }

  private setError(errorMessage: any): void {
    if (typeof errorMessage === 'object') errorMessage = this.dataExport.getDefaultErrorMessage();
    // エラーをキャッチした際共通エラーダイアログにセット
    this.$store.commit('hexabase/setIsError', true);
    this.$store.commit('hexabase/setErrorMessage', errorMessage);
  }

  private async confirmOpratipon() {
    this.apiDialog = false;
    this.apiDialogTableColumn = [];
    this.apiDialogErrData = [];
  }

  private getHeaderFields(formData: any) {
    const baseData = {
      cols: {},
      datas: {} as { [k: string]: any }
    };
    try {
      baseData.cols = this.dataExport.getGridStatus(formData);
      baseData.datas = formData;
    } catch (errorMessage) {
      this.setError(errorMessage);
    }
    return baseData;
  }

  private getHeaderData(setData: { [key: string]: any }, baseData: any) {
    try {
      Object.keys(setData).map((key: string) => {
        baseData.datas[key].props['value'] = setData[key];
      });
    } catch (errorMessage) {
      this.setError(errorMessage);
    }
  }

  private catchInput(input: any) {
    let conditionItem: { [key: string]: any } = {};

    if (input.value === undefined) return;
    if (input.type === undefined) {
      switch (input.name) {
        case 'service_type': {
          const item = this.dataFindItem(
            this.masterData['m_service_type'].body,
            'i_id',
            input.value
          );
          this.dataReportId = item.data_report_id_for_csv;
          // リース会社の項目index取得
          const findIndex = this.dataFindIndex(
            this.outputConditionsItems.datas,
            'display_id',
            'leasing_company_id'
          );
          if (findIndex !== -1) {
            if (item.service_type === 'OAリース') {
              this.outputConditionsItems.datas[findIndex].show = true;
            } else {
              this.outputConditionsItems.datas[findIndex].show = false;
            }
            this.clearOutputData();
          }
          break;
        }
        case 'customer_id':
        case 'company_id':
        case 'manager_id':
        case 'commodity_id':
        case 'leasing_company_id': {
          const item = this.masterData[CatchInputMasterIdList[input.name]]['body'].find(
            (item: any) => {
              if (item.i_id === input.value) {
                return item;
              }
            }
          );
          if (item !== undefined) {
            conditionItem['id'] = input.name;
            conditionItem['search_value'] = [input.value];
          }
          break;
        }
      }
    } else {
      if (input.type === 'datetime') {
        const dateData = this.dataExport.editDatetype(input.value, 'Asia/Tokyo', 'yyyy年M月');
        const item = JSON.parse(JSON.stringify(input));
        item.value = dateData;
        conditionItem = this.createSearchConditionList(item, this.csvPayload.conditions);

        const findIndex = this.dataFindIndex(
          this.outputConditionsItems.datas,
          'display_id',
          input.name
        );
        if (findIndex !== -1) {
          if (input.range === 'from') {
            this.outputConditionsItems.datas[findIndex].props.valueFrom = input.value;
          } else {
            this.outputConditionsItems.datas[findIndex].props.valueTo = input.value;
          }
        }
      } else {
        const findIndex = this.dataFindIndex(
          this.outputConditionsItems.datas,
          'display_id',
          input.name
        );
        if (findIndex !== -1) {
          this.outputConditionsItems.datas[findIndex].props.value = input.value;
        }
        conditionItem = this.createSearchConditionList(input, this.csvPayload.conditions);
      }
    }

    if (input.name !== 'service_type') {
      const findIndex = this.dataFindIndex(this.csvPayload.conditions, 'id', conditionItem.id);
      if (findIndex === -1) {
        this.csvPayload.conditions.push(conditionItem);
      } else {
        this.csvPayload.conditions[findIndex] = { ...conditionItem };
        if (!this.isSearchValue(conditionItem, input.range !== 'to' ? 0 : 1)) {
          this.csvPayload.conditions.splice(findIndex);
        }
      }
    }
  }

  private dataFindItem(findData: any, findDataString: string, findString: string) {
    const findItem = findData.find((item: any) => {
      if (item[findDataString] === findString) {
        return item;
      }
    });
    return findItem;
  }

  private dataFindIndex(findData: any, findDataString: string, findString: string) {
    const findIndex = findData.findIndex((item: any) => {
      if (item[findDataString] === findString) {
        return item;
      }
    });
    return findIndex;
  }

  private isSearchValue(searchVal: { [key: string]: string | string[] }, index: number) {
    if (searchVal.search_value !== undefined) {
      return searchVal.search_value[index].length === 0 ? false : true;
    } else {
      return true;
    }
  }

  /**
   * 出力条件作成処理
   * @param {object} input - 入力値
   * @param {array} searchConditions - 現状の検索条件
   * @returns {araay} 加工された検索条件
   */
  public createSearchConditionList(
    input: { [k: string]: string },
    searchConditions: Array<{ [key: string]: string | string[] }>
  ) {
    const condition: { [key: string]: any } = {};
    const type = input.type;

    switch (type) {
      case 'datetime': {
        condition['id'] = input.name;
        const range = input.range;
        const currentData = searchConditions.find(v => v.id === input.name);
        if (range && currentData === undefined) {
          if (range === 'from') {
            condition['search_value'] = [input.value, null];
          } else if (range === 'to') {
            condition['search_value'] = [null, input.value];
          }
        } else {
          if (currentData !== undefined) {
            condition['search_value'] = currentData.search_value;
          }
          const index = range === 'from' ? 0 : 1;
          condition['search_value'][index] = input.value;
        }
        break;
      }
      case 'number': {
        condition['id'] = input.name;
        condition['search_value'] = [input.value, input.value];
        break;
      }
      case 'dslookup': {
        condition['id'] = input.name;
        condition['search_value'] = [input.value];
        break;
      }
      case 'status': {
        condition['id'] = input.name;
        condition['search_value'] = typeof input.value === 'object' ? input.value : [input.value];
        break;
      }
      case 'text': {
        condition['id'] = input.name;
        condition['search_value'] = [input.value];
        condition['exact_match'] = false;
        break;
      }
      case 'select': {
        if (input.name === 'status') {
          condition['id'] = input.name;
          condition['search_value'] = input.value;
        } else {
          condition['id'] = input.name;
          condition['search_value'] = [input.value];
        }
        break;
      }
      default: {
        condition['id'] = input.name;
        condition['search_value'] = [input.value];
        break;
      }
    }
    return condition;
  }

  /**
   * 出力条件のクリアボタン押下処理
   */
  private clearButton() {
    // サービス種別の初期値をOAリースに戻す
    const serviceTypeFindItem = this.dataFindItem(
      this.masterData['m_service_type'].body,
      'service_type',
      'OAリース'
    );
    this.dataReportId = serviceTypeFindItem.data_report_id_for_csv;
    this.$set(
      this.dataReportOutputSelectServiceTypeDatas.datas[0].props.outPutData[0],
      'value',
      this.masterData['m_service_type']['body'][0]['service_type']
    );
    // 出力条件クリアを実行
    this.clearOutputData();
  }

  /**
   * 出力条件クリア
   */
  private clearOutputData() {
    // refを使用しformをリセット
    const form: any = this.$refs.form;
    form.reset();
    // CSV出力内容の初期化
    for(const index in this.outputConditionsItems.datas) {
      switch(this.outputConditionsItems.datas[index].component) {
        case 'MasterSelectSetControl': {
          this.outputConditionsItems.datas[index].props.outPutData[0].value = '';
          break;
        }
        case 'DatePickerRangeArea': {
          this.outputConditionsItems.datas[index].props.valueFrom = '';
          this.outputConditionsItems.datas[index].props.valueTo = '';
          break;
        }
      }
    }
    // 出力条件のクリア
    this.csvPayload.conditions = [];
  }
}
